export enum CheckinDenialReasons {
  AlreadyCheckedIn = 'Already Checked in',
  InvalidToken = 'Invalid Token',
  ExpiredToken = 'Expired Token',
  LimitReached = 'Visitors Limit Reached',
  VenueDisabled = 'Venue Disabled',
  InvalidArea = 'Invalid area'
}
